import axios from "axios";

let __isRetryRequest =false

const serverCall = (config) => {
  config.headers = {
    'Content-Type': 'application/json'
  }
  //interceptors handle network error
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {     
      console.log ('Error ', error.response.status)

      if (!error.response) {
        error.response = {
          data: 'net work error',
          status: 500
        }
      }
      if(error.response.status===504 ){
        if (__isRetryRequest === false) {
          __isRetryRequest = true
          return axios.request(config);
        }
        else
        throw error;
      }
      //400 invalid data
      //404 Not Found
      //unauthorized access
      if(error.response.status===401){
        throw error
      }
      return Promise.reject(error);
    });
//  config.baseURL = process.env.REACT_APP_RENTCYCLEAPI_URL
config.baseURL = '#{rentrackerapi}#'
  return axios(config)
}
export default serverCall
